import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';


const HeartIcon = () => {
  return (
    <FontAwesomeIcon className='mx-2' icon={faHeart} />
   
  );
};

export default HeartIcon;
